import {useQuery} from "@tanstack/react-query";
import * as api from "../api";


export const useCurrentUserAuthorizations = (props) => {
    return useQuery({
        queryKey: ['authorizations'],
        queryFn: () => api.Auth.getAuthorizations(),
        //staleTime: 1000 * 60 * 60 * 24 * 7, // 1 week,
        ...props
    });
}

export const useMeQuery = (props) => {
    return useQuery({
        queryKey: ['users', 'me'],
        queryFn: api.User.me,
        //staleTime: 1000 * 60 * 60 * 24 * 7, // 1 week,
        ...props
    });
}